import React, { useState, useMemo } from 'react';
import { Row, Col, Spinner } from 'reactstrap';

import { Document as ReactPdfDocument, Page as ReactPdfPage, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

import ReactPdfPagination from '../../../react_pdf/pagination';

const VersionerDocumentComparisonItem = (props) => {
  const {
    item,
  } = props

  const [document, setDocument] = useState({ currentPages: 0, totalPages: 0 });

  const filePath = useMemo(() => {
    return item.filePath;
  }, [item])

  const onLoadSuccess = (params) => {
    setDocument(prevState => {
      return {
        ...prevState,
        totalPages: params.numPages,
        currentPage: 1
      }
    })
  }

  const onChangePage = page => {
    setDocument(prevState => {
      return {
        ...prevState,
        currentPage: page
      }
    })
  }

  const renderLoading = () => {
    return (
      <div className='d-flex justify-content-center align-items-center w-100' style={{ backgroundColor: 'white', minHeight: 600 }}>
        <Spinner color="primary" />
      </div>
    )
  }

  const renderPDF = () => {
    if (props?.configuration?.isLoading) {
      return renderLoading();
    } else if (filePath) {
      return (
        <>
          <div className="paper">
            <div className="document-page p-0">
              <ReactPdfDocument
                file={filePath}
                onLoadSuccess={onLoadSuccess}
              >
                <ReactPdfPage
                  pageNumber={document.currentPage || 1}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </ReactPdfDocument>
            </div>
          </div>
          <div className='mt-3 text-center'>
            <ReactPdfPagination
              data={{
                currentPage: document.currentPage,
                totalPages: document.totalPages
              }}
              callbacks={{
                onChangePage: onChangePage
              }}
            />
          </div>
        </>
      )
    }
  }

  return (
    <Row>
      <Col>
        <div className="d-flex align-items-center">
          <p className="fw-bold d-inline mb-0 ml-2">
            { item?.name }
          </p>
        </div>
        <ul className="text-muted list-unstyled small ml-2">
          <li className="mr-3">
            <a href={filePath} download={true}>
              <i className="fas fa-download mr-2"></i>
              {item?.file_attachment?.filename || 'Archivo'}
            </a>
          </li>
          <li className="mr-3">
            <i className="fas fa-user mr-2"></i>
            Modificado por {item?.created_by?.email || 'Usuario'}
          </li>
        </ul>
        {renderPDF()}
      </Col>
    </Row>
  );
};

export default VersionerDocumentComparisonItem;
